const galleryImages = Array.from({ length: 56 }, (_, index) => {
  const imageNumber = index + 1;
  const paddedNumber = String(imageNumber).padStart(2, '0');

  return {
    id: imageNumber,
    src: `/gallery/gallery-${paddedNumber}.jpeg`,
    alt: `Totalguard Workwear Rosslyn product gallery image ${imageNumber}`
  };
});

export default galleryImages;
